subscribe(PUB_SUB_EVENTS["cartUpdate"], (event) => {
  console.log(event);
  const sections = event.cartData.sections;
  Object.keys(sections).forEach((sectionId) => {
    if (
      !(sectionId.includes("cart-items") || sectionId.includes("cart-footer"))
    )
      return;

    const section = sections[sectionId];

    document.querySelector("#shopify-section-" + sectionId).innerHTML =
      new DOMParser()
        .parseFromString(section, "text/html")
        .body.querySelector("#shopify-section-" + sectionId).innerHTML;
  });
});
